// Display-only: render a numeric 0 per-post metric count as a dash (matching G Network's zero
// rendering) for the Merges "Another State" campaign, its song page and its public share ONLY.
// No other artist/song/campaign, and no summary totals, rates, charts or budgets, are affected.
export const DASH_ZERO_CAMPAIGN_ID = "0b6ab495-8fbc-41f4-ba3e-5353180d1c4a";
export const DASH_ZERO_SONG_ID = "9c18764d-08b9-491c-a710-8e7fe483d273";
export const DASH_ZERO_SHARE_TOKEN = "EewOyBsFZP6-4vRnHYFqbg";
